import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import BannerOne from "../Components/Banner/BannerOne";
import CategoryOne from "../Components/Category/CategoryOne";
import VideoOne from "../Components/Video/VideoOne";
import DestinationOne from "../Components/Destination/DestinationOne";
import AboutOne from "../Components/About/AboutOne";
import GalleryOne from "../Components/Gallery/GalleryOne";
import CounterOne from "../Components/Counter/CounterOne";
import BrandOne from "../Components/Brand/BrandOne";
import FooterOne from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import SEO from "../Components/SEO/SEO";

function HomeOne() {
  return (
    <div>
      <SEO translationKey="seo.home" url="/" />
      <HeaderOne />
      <BannerOne />
      <CategoryOne />
      <VideoOne />
      <DestinationOne />
      <AboutOne />
      <GalleryOne />
      <CounterOne />
      <BrandOne className="space-bottom" />
      <FooterOne />
      <ScrollToTop />
    </div>
  );
}

export default HomeOne;
